export default __webpack_public_path__ + "static/media/MachineSpeedMinute.b9a6a1d1.jpg";